import React from 'react';
import data_hero from '../images/data_analytics_hero.png';
import '../css/media.css';
import '../css/bg.css';

const steps = [
  {
    title: "Data Preprocessing",
    icon: "🧮",
    text: "We cleanse and transform raw data into an understandable format. This vital step guarantees accuracy and consistency before deep analysis begins."
  },
  {
    title: "Extracting the Relevant Data",
    icon: "🎯",
    text: "Our experts identify and pull the most critical data points from vast datasets. This ensures your strategic decisions are based on what truly matters."
  },
  {
    title: "Data Filtering",
    icon: "🔍",
    text: "We apply advanced filtering techniques to eliminate noise and inconsistencies. Clean, refined data leads to sharper insights and reliable outcomes."
  },
  {
    title: "Report Generation",
    icon: "📈",
    text: "We compile our findings into intuitive, highly visual, and comprehensive reports. Empower your team with actionable intelligence delivered seamlessly."
  }
];

export default function dataAnalytics() {
  return (
    <div className='bg-light' style={{ minHeight: '100vh', paddingBottom: '60px' }}>

      {/* ── Hero Section ─────────────────────────── */}
      <div
        className="position-relative d-flex align-items-center justify-content-center text-center overflow-hidden"
        style={{
          width: '100%',
          height: '55vh',
          backgroundImage: `url(${data_hero})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          marginTop: '-1px'
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.5) 100%)',
            zIndex: 1
          }}
        />
        <div className="container position-relative px-4" style={{ zIndex: 2 }}>
          <p className="section-label animate-fade-up text-info mb-3">Modern Solutions</p>
          <h1 className="text-white fw-bold animate-fade-up delay-1" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.1 }}>
            DATA <span className="text-info">ANALYTICS</span>
          </h1>
          <p className="animate-fade-up delay-2 text-white-50 mt-4 mx-auto" style={{ maxWidth: '700px', fontSize: '1.15rem', lineHeight: 1.6 }}>
            Data is the "New Oil of the Digital Economy." We help our clients move to modern data solutions to unlock insights through statistical and quantitative analysis.
          </p>
        </div>
      </div>

      {/* ── Approach Section ─────────────────────── */}
      <div className="container py-6 mt-5">
        <div className="text-center mb-5">
          <p className="section-label">Methodology</p>
          <h2 className="section-title">How We Approach Data</h2>
        </div>

        <div className="row g-4 justify-content-center">
          {steps.map((step, index) => (
            <div className="col-md-6 col-lg-3 d-flex" key={index}>
              <div className="ftb-service-card w-100 p-4 text-center">
                <div className="ftb-card-accent mb-3" />
                <div style={{ fontSize: '3rem', margin: '15px 0' }}>
                  {step.icon}
                </div>
                <h5 className="fw-bold mb-3" style={{ color: 'var(--ftb-text)' }}>
                  {step.title}
                </h5>
                <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.95rem', lineHeight: 1.6, textAlign: 'left' }}>
                  {step.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Quote Section ────────────────────────── */}
      <div className='container py-5'>
        <div className="text-center section-title mx-auto" style={{ color: 'var(--ftb-text)', opacity: 0.9, maxWidth: '800px' }}>
          <div style={{ fontSize: '3rem', color: '#0dcaf0', marginBottom: '10px' }}>“</div>
          <div style={{ fontSize: '1.5rem', lineHeight: 1.4, fontWeight: '500' }}>
            TALENT WINS GAMES, BUT TEAMWORK AND INTELLIGENCE WINS CHAMPIONSHIPS.
          </div>
        </div>
      </div>

    </div>
  )
}
